import { ExportSheet } from './core';
import {
  ActExportPreparer,
  ArpExportPreparer,
  ContratoExportPreparer,
  ListagemAquisicoesExportPreparer,
  OrgInterExportPreparer,
  ProaqExportPreparer,
  TedExportPreparer,
} from './preparers';
import { ListagemCoresExportPreparer } from './preparers/listagemCores.preparer';
import { ListagemDominiosExportPreparer } from './preparers/listagemDominios.preparer';
import { ListagemDominiosSubtiposExportPreparer } from './preparers/listagemDominiosSubtipos.preparer';
import { ListagemDominiosTiposExportPreparer } from './preparers/listagemDominiosTipos.preparer';
import { ListagemFluxosAdminEtapasExportPreparer } from './preparers/listagemFluxosAdminEtapas.preparer';
import { ListagemFluxosAdminModelosExportPreparer } from './preparers/listagemFluxosAdminModelos.preparer';
import { ListagemModuloItensExportPreparer } from './preparers/listagemModuloItens.preparer';
import { ListagemModuloSubmodulosExportPreparer } from './preparers/listagemModuloSubmodulos.preparer';
import { ListagemModulosSisafExportPreparer } from './preparers/listagemModulosSisaf.preparer';

export interface DataPreparer {
  prepareForExport(
    selectedItems: any[],
    additionalData?: any,
  ): Promise<ExportSheet[]>;
}

export const baseLogColumns = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',
};

export class ExportPreparerFactory {
  static create(moduleName: string): DataPreparer {
    switch (moduleName.toLowerCase()) {
      case 'proaq':
        return new ProaqExportPreparer();
      case 'arp':
        return new ArpExportPreparer();
      case 'contrato':
        return new ContratoExportPreparer();
      case 'act':
        return new ActExportPreparer();
      case 'ted':
        return new TedExportPreparer();
      case 'orginters':
        return new OrgInterExportPreparer();
      case 'listagemaquisicoes':
        return new ListagemAquisicoesExportPreparer();
      // case 'fornecedores':
      //   // return new FornecedoresExportPreparer();
      case 'listagemcores':
        return new ListagemCoresExportPreparer();
      case 'listagemdominios':
        return new ListagemDominiosExportPreparer();
      case 'listagemdominiostipos':
        return new ListagemDominiosTiposExportPreparer();
      case 'listagemdominiossubtipos':
        return new ListagemDominiosSubtiposExportPreparer();
      case 'listagemmodulossisaf':
        return new ListagemModulosSisafExportPreparer();
      case 'listagemmodulossubmodulos':
        return new ListagemModuloSubmodulosExportPreparer();
      case 'listagemmoduloitens':
        return new ListagemModuloItensExportPreparer();
      case 'listagemfluxosadminmodelos':
        return new ListagemFluxosAdminModelosExportPreparer();
      case 'listagemfluxosadminetapas':
        return new ListagemFluxosAdminEtapasExportPreparer();
      default:
        throw new Error(
          `Preparador não encontrado para o módulo: ${moduleName}`,
        );
    }
  }
}
